import { Link } from 'react-router-dom'
import {
  ArtArmUpWithSickleCells,
  PatientAndPractionerTalking,
  SmilingDoctorCloseUp,
  SmilingSittingDoctor,
  TwoPractionersInLab
} from 'assets'

export const Hero: React.FC = () => {
  return (
    <div
      className="relative bg-transparent min-h-[500px] xl:min-h-[600px] px-6 py-12 xl:py-16"
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto flex flex-col xl:flex-row items-center gap-12 xl:gap-32">
        {/* Content - moved above image for smaller screens */}
        <div
          className="w-full xl:w-1/2 text-center xl:text-left xl:order-2"
          data-testid="hero-content"
        >
          <div className="max-w-2xl mx-auto xl:mx-0">
            <h1
              className="text-[#3C2416] text-3xl lg:text-4xl xl:text-5xl font-bold mb-6 xl:mb-8 leading-tight"
              data-testid="hero-heading"
            >
              Working Together to Combat Sickle Cell Disease
            </h1>
            <p
              className="text-[#142841] text-lg xl:text-xl mb-8 xl:mb-10 leading-relaxed"
              data-testid="hero-description"
            >
              Our mission is to support sickle cell disease centers in
              delivering high-quality comprehensive care by setting standards,
              promoting their adoption, identifying opportunities and resources
              to strengthen those centers, and advocating for access to
              comprehensive care to improve health outcomes, quality of life,
              and survival.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center xl:justify-start">
              <Link
                to="/join"
                className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-[#A6410A] text-white text-lg font-semibold hover:bg-[#8a3608] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                data-testid="hero-cta-button"
              >
                Become a member
              </Link>
              <Link
                to="/about-us"
                className="inline-flex items-center justify-center px-8 py-4 rounded-full border-2 border-[#3C2416] text-[#3C2416] text-lg font-semibold hover:bg-[#3C2416] hover:text-white transition-all duration-200"
                data-testid="hero-secondary-button"
              >
                Learn more
              </Link>
            </div>
          </div>
        </div>

        {/* Image Group - moved below content for smaller screens */}
        <div
          className="w-full xl:w-1/2 relative xl:order-1"
          data-testid="hero-image-group"
        >
          {/* Single image for under xl breakpoint - improved styling */}
          <div className="block xl:hidden max-w-lg mx-auto w-full">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <div
                className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200"
                data-testid="hero-image-xl"
              >
                <img
                  src={ArtArmUpWithSickleCells}
                  alt="Sickle cell disease awareness artwork"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              {/* Subtle overlay for better text contrast if needed */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent"></div>
            </div>
          </div>

          {/* Circular image arrangement for larger screens */}
          <div className="aspect-square relative hidden xl:block min-w-2xl">
            {/* Background circle */}
            <div className="absolute w-72 h-72 rounded-full bg-white top-20 left-0 shadow-2xl" />
            <div
              className="absolute w-72 h-72 rounded-full overflow-hidden top-22 left-2 shadow-2xl"
              data-testid="hero-image-main"
            >
              <img
                src={SmilingDoctorCloseUp}
                alt="Doctor smiling in professional headshot"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute w-64 h-64 rounded-full bg-white top-7/12 right-14 shadow-2xl" />
            <div
              className="absolute w-64 h-64 rounded-full overflow-hidden bottom-8 right-16 shadow-2xl"
              data-testid="hero-image-main"
            >
              <img
                src={SmilingSittingDoctor}
                alt="Doctor sitting and consulting with patient"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div
              className="absolute w-48 h-48 rounded-full bg-white bottom-14 left-16 shadow-2xl"
              data-testid="hero-image-tertiary"
            />
            <div
              className="absolute w-48 h-48 rounded-full overflow-hidden bottom-16 left-18 shadow-2xl"
              data-testid="hero-image-main"
            >
              <img
                src={TwoPractionersInLab}
                alt="Two practitioners working together in lab"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div
              className="absolute w-48 h-48 rounded-full bg-white top-30 right-30 shadow-2xl"
              data-testid="hero-image-quaternary"
            />
            <div
              className="absolute w-48 h-48 rounded-full overflow-hidden top-32 right-32 shadow-2xl"
              data-testid="hero-image-main"
            >
              <img
                src={PatientAndPractionerTalking}
                alt="Patient and practitioner in consultation"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
